customElements.define('iframe-modal', class extends HTMLElement {
  constructor() {
    super();
    this.iframe = this.querySelector('iframe');
    this.closeButton = this.querySelector('[data-button-close]')
    this.addEventListener('click', this.handleClickOutside.bind(this));
    window.addEventListener('keydown', this.handleEscClick.bind(this));
    this.addEventListener('click', this.handleClose.bind(this));

    this.classes = {
      hide: 'tw-hidden'
    }
  }

  play(src, playButtonElement) {
    this.iframe.focus();
    this.initButton = playButtonElement;
    this.classList.remove(this.classes.hide);
    this.iframe.src = src;
  }

  stop() {
    this.iframe.src = '';
  }

  handleClose() {
    this.classList.add(this.classes.hide);
    this.stop();
    if (this.initButton) {
      this.initButton.focus();
    }
  }

  handleClickOutside(e) {
    if (e.target === this) {
      this.handleClose()
    }

  }

  handleEscClick(e) {
    if (e.keyCode === 27) {
      this.handleClose()
    }

  }
});
